import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { Provider } from 'react-redux';
import { BrowserRouter } from 'react-router-dom';
import {persistor,store} from './Redux/store';
import { PersistGate } from "redux-persist/integration/react";
const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(
  <Provider store={store}>
    <BrowserRouter>
      {/* <React.StrictMode> */}
      <PersistGate loading={null} persistor={persistor}>
        <App />
        </PersistGate>
      {/* </React.StrictMode> */}
    </BrowserRouter>
  </Provider>
);


